export default __webpack_public_path__ + "static/media/M_wdt_c_cap_4.2e998965.mp3";